'use client';

import { KEYBOARD_DELAY, SELECTOR } from './constants';
import { getFlowHeight } from './dom';

/** 상품 목록 위에 쌓이는 요소들. 이 높이를 빼야 목록 상단이 화면 위에 온다 */
const ABOVE_LIST = [
  SELECTOR.header,
  SELECTOR.input,
  SELECTOR.filterBar,
  SELECTOR.sorting,
  SELECTOR.seat,
];

/**
 * 검색 인풋 onFocus 핸들러.
 * 키보드가 완전히 올라온 뒤 상품 목록 상단이 보이도록 스크롤을 맞춘다.
 */
export const inputFocusTop = (): void => {
  const $above = ABOVE_LIST.map(selector => document.querySelector(selector));
  const $list = document.querySelector(SELECTOR.list);

  // 키보드가 올라온 뒤 위치를 재도록 한 박자 늦게 계산한다
  setTimeout(() => {
    const rect = $list?.getBoundingClientRect();
    if (!rect) return;

    const offset = $above.reduce((total, $el) => total + getFlowHeight($el), 0);
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    window.scrollTo({ top: rect.top + scrollTop - offset });
  }, KEYBOARD_DELAY);
};
